// https://github.com/pillarjs/path-to-regexp#readme
import { compile, match } from 'path-to-regexp';

import type { Locality } from '@rover/types/src/Locality';
import { Http404Error } from '@rover/utilities/HttpError';

const LOCALITY_REGEX = '/:country/:region/:city?/:neighborhood?/';

export const localityToPath = (locality: Locality): string => compile(LOCALITY_REGEX)(locality);

export const pathToLocality = (path: string): Locality => {
  const pathWithoutQuery = path.split('?')[0];
  const output = match(LOCALITY_REGEX)(pathWithoutQuery);
  if (!output) throw new Http404Error(`Unable to convert path "${path}" to Locality.`);
  return output.params as Locality;
};
